export function capitalize(str) {
    return str.replace(/\b[a-z]/g, (l) => {
        return l.toUpperCase();
    });
}
//# sourceMappingURL=capitalize.js.map